/**
 * Layout: compact — a horizontal row.
 *
 * For dense contexts where vertical space is the constraint, not width:
 * search results, "you might also like" rails, cart-adjacent lists.
 *
 * Explicitly nested rather than one flex row with wrap. Wrapping put the price
 * on its own line and let the CTA crowd the title, because the pieces have very
 * different intrinsic widths. Two stacked groups — identity, then commerce —
 * gives the same visual result deterministically at any column width.
 *
 * Drops the pieces that only earn their space in a tall card: offers, the
 * consumer-discount ribbon, and the swatch/size rows.
 */

import { el } from '../../dom.js';
import { renderAction } from '../action/index.js';
import {
	renderMedia,
	renderTitleRow,
	renderCategory,
	renderRating,
	renderPrice,
	renderStock,
	renderActionsSlot,
} from './_shared.js';
import { cardRoot } from './root.js';

export function render(model, ctx) {
	const identity = el('div', { class: 'rfhq-pc-compact-main' }, [
		renderTitleRow(model, ctx),
		renderCategory(model),
		renderRating(model),
	]);

	const commerce = el('div', { class: 'rfhq-pc-compact-foot' }, [
		el('div', { class: 'rfhq-pc-compact-money' }, [renderPrice(model, ctx), renderStock(model)]),
		renderActionsSlot(model, ctx, renderAction),
	]);

	const body = el('div', { class: 'card-body rfhq-pc-body' }, [identity, commerce]);
	return cardRoot(model, ctx, 'compact', [renderMedia(model), body]);
}
